<template>
  <v-dialog v-model="dialog" persistent width="300px">
    <v-card
      ><v-card-title
        ><h2>
          {{ selectedIndex == -1 ? "Add New Keyword" : "Edit Keyword" }}
        </h2></v-card-title
      >
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-text-field
            label="Keyword"
            v-model="msg"
            :rules="[(v) => !!v || 'Required']"
          ></v-text-field></v-form
      ></v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer
        ><v-btn
          flat
          color="error"
          :disabled="isLoading"
          @click="$emit('cancel')"
          >Cancel</v-btn
        >
        <v-btn color="success" :loading="isLoading" @click="submit()"
          >Submit</v-btn
        ></v-card-actions
      ></v-card
    >
  </v-dialog>
</template>

<script>
export default {
  props: ["dialog", "selectedIndex", "selectedItem"],
  data() {
    return {
      valid: true,
      msg: "",
      isLoading: false,
    };
  },
  watch: {
    dialog() {
      if (this.dialog == true) {
        this.$refs.form.resetValidation();
        if (this.selectedIndex != -1) {
          this.msg = this.selectedItem.blacklist_area_keyword;
        }
      }
    },
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.isLoading = true;
        let _this = this;
        let form = {
          keyword: this.msg,
          done() {
            _this.msg = "";
            _this.isLoading = false;
          },
        };
        if (this.selectedIndex == -1) {
          this.$emit("create", form);
        } else {
          this.$emit("edit", form);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>